import { useMutation, useClient } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { email, name } from 'Data/validate.js'

import mutation from './mutation.graphql.js'
import mutation_set_default from './mutation-set-default.graphql.js'
import query from './query.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let [, executeMutationDefaults] = useMutation(mutation_set_default)
  let setFlowTo = useSetFlowTo(props.viewPath)
  let client = useClient()

  return async function onSubmit({ value, change, originalValue }) {
    let isInvalid = !name(value.name) || !email(value.email)

    if (isInvalid) {
      return true
    }

    let mutationResponse = await executeMutation({
      name: value.name,
      email: value.email,
    })

    if (mutationResponse.error) {
      notify(notifyError('Something went wrong. Please try again later.'))
      return
    }

    if (value.set_default) {
      let { data: locations } = await client.query(query, {}).toPromise()

      let defaults = locations.session_user_locations.map(location => ({
        type: 'email',
        location_id: location._id,
        sender_id: mutationResponse.data.insert_comms_outbound_emails_one.id,
      }))

      await executeMutationDefaults({
        defaults,
      })
    }
    change(originalValue)

    notify(notifySuccess('Email address added.'))
    setFlowTo(normalizePath(props.viewPath, 'AddEmail/No'))
  }
}
